exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".b-btn__icon[data-v-0e6cc7aa]{color:#8a8a8a!important}.icon-arrow_back-navbar[data-v-0e6cc7aa]{fill:#aaa;height:24px;width:24px}.b-page[data-v-0e6cc7aa]{background:#292929}.w-navbar[data-v-0e6cc7aa]{background-color:#292929}.w-navbar .text[data-v-0e6cc7aa]{color:#fff;text-transform:none}", ""]);

// exports
